jQuery(document).ready(function ($) {
	var windowWidth = $(window).width();

	var links = document.links;
	for (let i = 0, linksLength = links.length; i < linksLength; i++) {
		if (
			links[i].hostname !== window.location.hostname &&
			!links[i].classList.contains('icon--account')
		) {
			links[i].target = '_blank';
		}
	}

	/******************************************
    Header Search
  ******************************************/

	// Show desktop search on click and focus on input
	$('.icon--search').on('click', function (e) {
		e.preventDefault();

		$('.desktop-search').fadeIn('fast', '', function () {
			$('body').addClass('search-open');
			$('.desktop-search input').focus();
		});
	});

	// Close desktop search if click outside
	$('body').on('click', function (e) {
		var desktopSearch = $('.desktop-search');

		if (
			!desktopSearch.is(e.target) &&
			desktopSearch.has(e.target).length === 0 &&
			$('body').hasClass('search-open')
		) {
			desktopSearch.fadeOut('fast', '', function () {
				$('body').removeClass('search-open');
				$('.icon--search').focus();
				$('#boost-sd__search-widget-init-wrapper').addClass(
					'boost-sd__g-hide'
				);
			});
		}
	});

	// var $form = $('#LocalizationForm');

	// $form.find('button').on('click', function (e) {
	// 	e.preventDefault();
	// 	e.stopPropagation();

	// 	var $select = $(this).closest('div').find('.custom-select');

	// 	$select.slideToggle(170);
	// 	$select.attr('aria-expanded', function (i, attr) {
	// 		return attr === 'true' ? 'false' : 'true';
	// 	});
	// });

	// // prevent inside clicks from closing
	// $form.find('.custom-select').on('click', function (e) {
	// 	e.stopPropagation();
	// });

	// // click outside → close if open
	// $(document).on('click', function () {
	// 	var $open = $form.find('.custom-select:visible');

	// 	if ($open.length) {
	// 		$open.slideUp(170).attr('aria-expanded', 'false');
	// 	}
	// });

	// $('#LocalizationForm .localization-country .custom-select a').on(
	// 	'click',
	// 	function (e) {
	// 		e.preventDefault();

	// 		const countryCode = $(this).data('country');
	// 		const $form = $('#LocalizationForm');
	// 		const $select = $form.find('select[name="country_code"]');

	// 		// update select value
	// 		$select.val(countryCode);

	// 		// trigger change so Shopify internal scripts notice
	// 		$select.trigger('change');

	// 		// optional: update button text
	// 		const countryText = $(this).text();
	// 		$form.find('#country-select .country-name').text(countryText);

	// 		// submit form
	// 		$form.submit();
	// 	}
	// );

	/******************************************
    Mobile Menu
  ******************************************/

	// Trigger mobile menu display
	$('.mobile-trigger').on('click', function () {
		$(this).toggleClass('active');

		$('html').toggleClass('mobile-menu-open');

		$('.mobile-menu').fadeToggle(170, '', function () {});
	});

	$(document).on(
		'click',
		'.mobile-menu .top-level.has-children a',
		function (e) {
			e.preventDefault();

			var dataTitle = $(this).attr('data-title');

			$('.mobile-menu__front').fadeOut(170, function () {
				$('.mobile-menu__back[data-title="' + dataTitle + '"]').fadeIn(
					170
				);
			});
		}
	);

	$(document).on('click', '.mobile-menu .sub__heading .back', function () {
		$('.mobile-menu__back').fadeOut(170, function () {
			setTimeout(function () {
				$('.mobile-menu__front').fadeIn(220);
			}, 150);
		});
	});

	/******************************************
   Quick Buy Modal
  ******************************************/
	$(document).on('click', '.card--product .btn--quick-buy', function () {
		var $trigger = $(this);
		var productHandle = $trigger.attr('data-handle');
		var modalID = $trigger.attr('data-id');
		var noVars = false;

		$trigger.find('.loader').css('opacity', 1);
		$trigger.attr('disabled', 'disabled');

		if ($trigger.hasClass('no-variants')) {
			noVars = true;
		}

		loadQuickViewProduct(productHandle, modalID, noVars, $trigger);
	});

	$('body').on('click', '.boost-sd-layout .btn--quick-buy', function (e) {
		e.preventDefault();
		var $trigger = $(this);
		var productHandle = $trigger.attr('data-handle');
		var noVars = false;

		$trigger.find('.loader').css('opacity', 1);
		$trigger.attr('disabled', 'disabled');

		loadQuickViewProduct(
			productHandle,
			'quick-view_collection',
			noVars,
			$trigger
		);
	});

	/******************************************
   Product Card Swatch Images
  ******************************************/
	$('.card__swatches .swatch').on('mouseenter', function () {
		var $this = $(this);
		var dataImage = $this.attr('data-image');
		var dataImageSrcset = $this.attr('data-image-srcset');
		var dataColor = $this.attr('data-color');
		// console.log(dataImage);
		if (dataImage.indexOf('no-image') === -1) {
			var newImage =
				'<img src="' +
				dataImage +
				'" srcset="' +
				dataImageSrcset +
				'" class="image--swatch image" style="display:none;" data-color="' +
				dataColor +
				'"/>';

			$this.closest('.card').find('.card__image a').append(newImage);
			$this.closest('.card').find('.image--swatch').show();

			$this
				.closest('.card')
				.find('.swatch')
				.removeClass('swatch--active');

			$this.addClass('swatch--active');
		}
	});

	$('.card__swatches .swatch').on('mouseleave', function () {
		$(this).closest('.card').find('.image--swatch').hide();

		$(this).closest('.card').find('.image--swatch').remove();

		$(this).removeClass('swatch--active');
	});

	/******************************************
    Modals
  ******************************************/

	// Launch the modal
	$('body').on('click', '.btn--modal', function (e) {
		e.preventDefault();
		e.stopPropagation();
		var modalID = '#' + $(this).attr('data-modal');
		// console.log(modalID);

		if ($(this)[0].hasAttribute('data-video-yt')) {
			var videoID = $(this).attr('data-video-yt');
			$(modalID)
				.find('.modal__inner')
				.append(
					'<div class="iframe-wrap"><iframe width="560" height="315" src="https://www.youtube.com/embed/' +
						videoID +
						'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>'
				);
		}

		if ($(this)[0].hasAttribute('data-video-vimeo')) {
			var videoID = $(this).attr('data-video-vimeo');
			$(modalID)
				.find('.modal__inner')
				.append(
					'<div class="iframe-wrap"><iframe width="560" height="315" src="https://player.vimeo.com/video/' +
						videoID +
						'"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen allowfullscreen></iframe></div>'
				);
		}

		$(modalID).fadeIn('fast');
	});

	// Close the modal
	$(document).on('click', '.modal--close, .modal__bg', function (e) {
		e.preventDefault();
		closeModal($(this));
	});

	/******************************************
  Quick View Modal from Product Card ( Process ATC / Variant Options Select )
  ******************************************/

	$('body').on('change', '.modal--quick .option__wrap select', function () {
		quickViewVariant();
	});

	$('body').on('click', '.modal--quick .option__wrap button', function () {
		quickViewVariant();
	});
});

function getQuickViewFetchUrl(productHandle) {
	var path = '/products/' + productHandle + '?view=data';

	if (window.location.origin) {
		return window.location.origin + path;
	}

	return (window.Shopify.routes.root || '/') + path.replace(/^\//, '');
}

function loadQuickViewProduct(productHandle, modalID, noVars, $trigger) {
	fetch(getQuickViewFetchUrl(productHandle))
		.then(function (response) {
			return response.text();
		})
		.then(function (html) {
			quickBuyData(html, modalID, noVars);

			if ($trigger) {
				$trigger.find('.loader').css('opacity', 0);
				$trigger.prop('disabled', '');
			}
		})
		.catch(function (error) {
			console.error('Error:', error);

			if ($trigger) {
				$trigger.find('.loader').css('opacity', 0);
				$trigger.prop('disabled', '');
			}
		});
}

function closeModal(object) {
	var modal = object.closest('.modal');

	modal.fadeOut('fast', function () {
		$('.modal__inner .iframe-wrap').remove();

		if (modal.hasClass('modal--quick')) {
			modal.find('.panel__inner').empty();
		}
	});
}
